import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/MainMenuView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')  
  },
  {
    path: '/register',
    name: 'register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "register" */ '../views/RegisterView.vue')
  },
  {
    path: '/subscribe',
    name: 'subscribe',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "subscribe" */ '../views/SubscribeBlurbView.vue')
  },
  {
    path: '/logoff',
    name: 'logoff',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "logoff" */ '../views/LogoffView.vue')
  },
  {
    path: '/passwordreset',
    name: 'passwordreset',
    component: () => import('../views/PasswordResetView.vue')
  },
  {
    path: '/stripe_success',
    name: 'stripe_success',
    component: () => import('../views/StripeSuccessView.vue')
  },
  {
    path: '/stripe_cancel',
    name: 'stripe_cancel',
    component: () => import('../views/StripeCancelView.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/ContactView.vue')
  },
  {
    path: '/verify',
    name: 'Verify Email',
    component: () => import('../views/SendEmailVerifyView.vue')
  },
  {
    path: '/emailverified',
    name: 'Email Verified',
    component: () => import('../views/EmailVerifiedView.vue')
  },
  {
    path: '/lichessmenu',
    name: 'Lichess Menu',
    component: () => import('../views/LichessMenuView.vue')
  },
  {
    path: '/lichesschallenge',
    name: 'Lichess Challenge',
    component: () => import('../views/LichessChallengeView.vue')
  },
  {
    path: '/enginemenu',
    name: 'Engine Menu',
    component: () => import('../views/EngineMenuView.vue')
  },
  {
    path: '/verbalplay',
    name: 'Verbal Play',
    component: () => import('../views/VerbalPlayView.vue')
  },
  {
    path: '/accountmenu',
    name: 'Account Menu',
    component: () => import('../views/AccountMenuView.vue')
  },
  {
    path: '/supportmenu',
    name: 'Support Menu',
    component: () => import('../views/SupportMenuView.vue')
  },
  {
    path: '/gamehistory',
    name: 'Game History',
    component: () => import('../views/GameHistoryView.vue')
  },
  {
    path: '/gamereview',
    name: 'Game Review',
    component: () => import('../views/GameReviewView.vue')
  },
  {
    path: '/lichessplay',
    name: 'Lichess Play',
    component: () => import('../views/LichessPlayView.vue')
  },
  {
    path: '/lichessopen',
    name: 'Lichess Open',
    component: () => import('../views/LichessOpenView.vue')
  },
  {
    path: '/lichessarena',
    name: 'Lichess Arena',
    component: () => import('../views/LichessArenaView.vue')
  },
  {
    path: '/lichessfriends',
    name: 'Lichess Friends',
    component: () => import('../views/LichessFriendView.vue')
  },
  {
    path: '/lichessconnect',
    name: 'Lichess Connect',
    component: () => import('../views/LichessConnectView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
